import React from 'react';
import { Flex, Text } from '@huspy/briks-web';
import useDeleteBankApplicationDocument from '@modules/opportunities/entities/bankApplication/mutation/useDeleteBankApplicationDocument';
import { useTranslation } from 'react-i18next';
import Loader from '@shared/loader';

type DocumentItemProps = {
  document: {
    document_external_id: string;
    file_name: string;
  };
  bankApplicationId: string;
  opportunityId: string;
};

export const UploadedDocument: React.FC<DocumentItemProps> = ({
  document,
  bankApplicationId,
  opportunityId,
}) => {
  const { t } = useTranslation();

  const {
    mutateAsync: deleteBankDocument,
    isPending: isBankFormDeleting,
  } = useDeleteBankApplicationDocument(opportunityId);

  const deleteDocument = async () => {
    await deleteBankDocument({
      documentId: document.document_external_id,
      bankApplicationId,
    });
  };

  return (
    <Flex
      key={ document.document_external_id }
      backgroundColor='#F9FAFB'
      borderRadius='12px'
      py='3'
      px='4'
      borderColor='border-secondary'
      background='bg-secondary'
      borderWidth='1px'
      gap='2'
      direction='column'
    >
      <Text size='lg' weight='medium'>
        {document.file_name}
      </Text>

      <Flex gap='spacing-3'>
        <Text
          size='sm'
          weight='medium'
          color='text-secondary'
          cursor='pointer'
          onClick={ deleteDocument }
        >
          {isBankFormDeleting ? (
            <Loader data-testId='loader' />
          ) : (
            t('opportunity.caseSubmission.documentSubmission.delete')
          )}
        </Text>
      </Flex>
    </Flex>
  );
};
